import axios from 'axios';
import Config from '../actions/Config';
import AccessToken from '../actions/AccessToken';

const BASE_URL = Config();
const getUpdates = {};
const token = AccessToken();

getUpdates.Updatesinfo = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 

export default getUpdates